import { COMPANY } from './config.js';
import { readJson } from './storage.js';
const KEY = 'vendeySvelteLogs:' + COMPANY;
export function serviceLogs() { return readJson(KEY, []); }
export function logService(operation, message) {
  try { localStorage.setItem(KEY, JSON.stringify([...serviceLogs(), { fecha: new Date().toISOString(), operacion: operation, mensaje: String(message).slice(0, 500) }].slice(-100))); } catch { /* El registro no bloquea la operación. */ }
}

export function clearServiceLogs() { localStorage.removeItem(KEY); }
